{
  "INBOX": {
    "LIST": {
      "TITLE": "My Inbox",
      "DISPLAY_DROPDOWN": "Відобразити",
      "LOADING": "Завантаження сповіщень",
      "404": "Немає активних сповіщень у цій групі.",
      "NO_NOTIFICATIONS": "Немає сповіщень",
      "NOTE": "Сповіщення від усіх підписок на вхідні повідомлення",
      "NO_MESSAGES_AVAILABLE": "Ой! Не вдалося отримати повідомлення",
      "SNOOZED_UNTIL": "Відкладено до",
      "SNOOZED_UNTIL_TOMORROW": "Відкладено до завтра",
      "SNOOZED_UNTIL_NEXT_WEEK": "Відкладено до наступного тижня"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Відключити сповіщення",
      "DELETE": "Видалити сповіщення",
      "BACK": "Назад"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Ви були згадані в розмові",
      "CONVERSATION_CREATION": "Діалог створено",
      "CONVERSATION_ASSIGNMENT": "Розмова була призначена для вас",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Нове повідомлення в призначеній розмові",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Нове повідомлення в розмові, в якій ви берете участь",
      "SLA_MISSED_FIRST_RESPONSE": "Перша відповідь на SLA пропущена для розмови",
      "SLA_MISSED_NEXT_RESPONSE": "Запропонована відповідь SLA відсутня для розмови",
      "SLA_MISSED_RESOLUTION": "Цільова роздільна здатність SLA відсутня для розмови"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Mentioned",
      "CONVERSATION_ASSIGNMENT": "Assigned to you",
      "CONVERSATION_CREATION": "New Conversation",
      "SLA_MISSED_FIRST_RESPONSE": "SLA breach",
      "SLA_MISSED_NEXT_RESPONSE": "SLA breach",
      "SLA_MISSED_RESOLUTION": "SLA breach",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Нове повідомлення",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Нове повідомлення",
      "SNOOZED_UNTIL": "Snoozed for {time}",
      "SNOOZED_ENDS": "Snooze ended",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Нове повідомлення"
    },
    "NO_CONTENT": "Немає вмісту",
    "MENU_ITEM": {
      "MARK_AS_READ": "Позначити як прочитане",
      "MARK_AS_UNREAD": "Позначити як непрочитане",
      "SNOOZE": "Відкласти",
      "DELETE": "Видалити",
      "MARK_ALL_READ": "Позначити всі як прочитані",
      "DELETE_ALL": "Видалити все",
      "DELETE_ALL_READ": "Видалити всі прочитані"
    },
    "DISPLAY_MENU": {
      "SORT": "Сортувати",
      "DISPLAY": "Відобразити :",
      "SORT_OPTIONS": {
        "NEWEST": "Новіші",
        "OLDEST": "Старіші",
        "PRIORITY": "Пріоритет"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Відкладено",
        "READ": "Прочитано",
        "LABELS": "Мітки",
        "CONVERSATION_ID": "ID бесіди"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Повідомлення помічено як прочитане",
      "MARK_AS_UNREAD": "Повідомлення помічено як непрочитане",
      "SNOOZE": "Сповіщення відключено",
      "DELETE": "Сповіщення видалено",
      "MARK_ALL_READ": "Повідомлення помічено як прочитане",
      "DELETE_ALL": "Сповіщення видалено",
      "DELETE_ALL_READ": "Всі прочитані повідомлення видалено"
    },
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Вихідний виклик — з'єднано",
      "OUTBOUND_FAILED": "Вихідний виклик — помилка",
      "INBOUND_MISSED": "Вхідний виклик — пропущений",
      "INBOUND_UNANSWERED_MISSED": "Вхідний виклик — пропущений без відповіді",
      "INBOUND_AGENT": "Вхідний виклик — відповів агент",
      "INBOUND_IVR": "Вхідний виклик — відповів IVR",
      "DEFAULT": "Телефонний виклик"
    }
  }
}
